var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.cols}},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"flex-grow-1 section-line"},[_c('div',{staticClass:"ml-4"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }